import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../sections/Footer";

const SECTIONS = [
  {
    h: "1. Acceptance of Terms",
    p: [
      "By accessing this website or using the services of Iron Gate Consulting, formerly Assets Secure USA, you agree to these Terms of Service. If you do not agree, please do not use this website or our services.",
    ],
  },
  {
    h: "2. Our Services",
    p: [
      "Iron Gate Consulting provides living trust setup, asset protection structuring, and coordination of legal review services for estate planning purposes. Intake is completed through our portal at trust.igcfirm.com. You review everything before you pay, and you receive a personal call before anything finalizes.",
      "Iron Gate Consulting is not a law firm and does not provide legal advice. Legal review services are provided by licensed attorneys through veteran military benefits and are available based on your location. Consult a licensed attorney for legal advice specific to your situation.",
    ],
  },
  {
    h: "3. Fees and Payment",
    p: [
      "Current pricing is displayed on this website: Basic Trust at $1,497 and Private Trust at $2,497, with the option to start basic and upgrade to private for $1,000 more when you are ready. No payment is required until you have completed your intake, received your personal call, and confirmed you are satisfied. Fees are due before your completed trust is released to you.",
    ],
  },
  {
    h: "4. Your Responsibilities",
    p: [
      "You agree to provide accurate and complete information during intake, including details about your assets and beneficiaries. The effectiveness of your trust depends on the accuracy of the information you provide and on properly funding the trust after it is delivered. You are responsible for reviewing your documents and asking questions before finalizing.",
    ],
  },
  {
    h: "5. Free Trust Review",
    p: [
      "If you submit an existing trust for review, the review is provided at no cost and with no commitment. The review is an assessment of structure and completeness and does not constitute legal advice.",
    ],
  },
  {
    h: "6. Intellectual Property",
    p: [
      "All content on this website, including text, design, graphics, and branding, is the property of Iron Gate Consulting or Echo Holding Ventures Inc. and may not be reproduced without written permission. Documents prepared for you become yours upon delivery.",
    ],
  },
  {
    h: "7. Limitation of Liability",
    p: [
      "To the maximum extent permitted by law, Iron Gate Consulting shall not be liable for indirect, incidental, or consequential damages arising from your use of this website or our services. Our total liability for any claim shall not exceed the amount you paid for the services giving rise to the claim.",
    ],
  },
  {
    h: "8. Termination",
    p: [
      "You may discontinue the intake process at any time before payment with no obligation. We reserve the right to decline or discontinue service where we cannot responsibly complete a file, in which case any fees paid for undelivered work will be refunded.",
    ],
  },
  {
    h: "9. Changes to These Terms",
    p: [
      "We may update these Terms of Service from time to time. Changes will be posted on this page with an updated effective date. Continued use of the website or services after changes are posted constitutes acceptance of the revised terms.",
    ],
  },
  {
    h: "10. Contact",
    p: [
      "Questions about these Terms of Service can be sent to support@igcfirm.com.",
    ],
  },
];

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-ink min-h-screen">
      <Navbar />
      <main className="pt-32 pb-24" data-testid="terms-page">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Link
            to="/"
            data-testid="terms-back-link"
            className="inline-flex items-center gap-2 text-gold text-sm tracking-[0.14em] uppercase font-semibold hover:text-goldlight transition-colors duration-300"
          >
            <ArrowLeft size={15} /> Back to Home
          </Link>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-cream tracking-tight leading-[1.06] mt-8">
            Terms of <em className="text-gold italic">Service</em>
          </h1>
          <p className="text-cream/50 text-sm mt-4 tracking-wide">Effective date: June 2026 · Iron Gate Consulting, formerly Assets Secure USA</p>

          <div className="mt-12 space-y-10">
            {SECTIONS.map((s) => (
              <section key={s.h}>
                <h2 className="font-display text-2xl text-cream">{s.h}</h2>
                {s.p.map((para, i) => (
                  <p key={i} className="text-cream/65 leading-relaxed text-sm sm:text-base mt-4">{para}</p>
                ))}
              </section>
            ))}
          </div>

          <p className="text-cream/40 text-xs leading-relaxed mt-14 pt-8 border-t border-white/8">
            Iron Gate Consulting is not a law firm. Legal review services are provided through veteran
            military benefits. Trust services are provided for estate planning purposes. Consult a licensed
            attorney for legal advice.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
